<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header"/>
    </template>
    <template slot="table-core">
      <base-table-pagination
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component
        ref="grid"
        v-model="selected"
        :value-key="['SerialNumber', 'TipoCertificado', 'idCliente']"
        :id-vista="idVista"
        :spanish="spanish"
        :data='data'
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        @actionclick='openPath'
        @datastatechange='dataStateChange'>
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <base-button-responsive v-if="hasModuleImportaciones && !isRoleUserOrConsulta" mode='primary' :text="$t('imports.import_certs_pfx_import')" icon='import' @click='toggleImport' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
          <!-- <base-button-responsive v-if="hasModuleImportaciones && !isRoleUserOrConsulta" mode='primary' :text="$t('imports.import_certs_serial_import')" icon='import' @click='toggleImportCertsSerial' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/> -->
          <base-button-responsive data-v-step="2" v-if="!isNotice" mode="primary" :text="$t('certificates.new_certificate')" icon="plus" @click="goToNewCertificate" :loading="isGeneralLoading"/>
        </template>
      </base-footer>
      <base-table-select-actions-expand
        :baseDropDownVisible="accionesCertificados.length > 0"
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
      >
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in accionesCertificados" :key="action.id">
              <base-button-item-list theme="dark"  @click="executeAction(action)">
                <base-icon :name="action.icon" class="mr-2" />
                {{ action.name }}
            </base-button-item-list>
          </span>
          <!-- <span>
             <base-button-item-list theme="dark" @click="deleteCertificate">
            <base-icon name="trash" class="mr-2" />
            $t('app.remove')
          </base-button-item-list>
          </span> -->
        </template>
      </base-table-select-actions-expand>
      <Dialog
        :title="$t('certificates.delete_certificate')"
        :visible.sync="showModal"
        width="40%"
        custom-class="min-width-dialog"
        center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue"  :text="$t('app.accept')" @click="() => {deleteHandler(); showModal = false}"/>
          </div>
        </template>
      </Dialog>
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>

        
      <import-cert-dialog
        :dialogOpen="showModalImport" 
        @toggleDialog="toggleImport" 
        @applyDialog="applyImport"
        :header="$t('imports.import_certs_pfx_header')" 
        :headerValue="$t('imports.pass_cert')" 
        :switchHeaderValue="$t('imports.type_import')" 
        :switchHeaderValueActive="$t('imports.type_import_certs_companies')"
        :switchHeaderValueInactive="$t('imports.type_import_only_certs')"
        />
      <import-generic-dialog
        :dialogOpen="showModalImportCertsSerial"
        @toggleDialog="toggleImportCertsSerial"
        @applyDialog="applyImportCertsSerial"
        @downloadTemplate="downloadTemplateCertsSerial"
        :header="$t('imports.import_certs_serial_header')" 
        />
    </template>
  </list-layout>
</template>

<script>
import { bus } from '@/main'

import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/CertificatesFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import { getCertificatesPag } from '@/services/certificates/getCertificatesPag'
// import moment from 'moment'
import { i18n } from '@/i18n'
import { downloadExcel } from '@/services/certificates/downloadExcel'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import { Dialog } from 'element-ui'
import { deleteCertificate } from '@/services/certificates/deleteCertificate'

/// Imports
// PFX
import ImportCertDialog from '@/components/ImportCertDialog.vue'
import { importCertificates } from '@/services/configurations/imports/importCertificates'

// Genericos
import ImportGenericDialog from '@/components/ImportGenericDialog.vue'

import { importCertsSerial } from '@/services/configurations/imports/importCertsSerial'
import { downloadTemplateCertsSerial } from '@/services/configurations/imports/downloadTemplateCertsSerial'

export default {
  name: 'certificates-list-view',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    Dialog,
    ImportCertDialog,
    ImportGenericDialog,
  },
  data: function () {
    return {
      idVista: 6,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // Import
      showModalImport: false,
      showModalImportCertsSerial: false,
      // All
      accionesCertificadosBase: [
        {
          id: 1,
          icon: 'switchhorizontal',
          name: i18n.t('app.replace')
        },
        {
          id: 2,
          icon: 'trash',
          name: i18n.t('app.remove')
        },
      ],
      loadingExcel: false,
      spanish: true,
      showModal: false,
      header: {
        title: i18n.t('certificates.header'),
        icon: 'certificates',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'certificates',
      hasClientFilterData: false,
      selectedField: 'selected',
      onlySelected: false,
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      tableData: [],
      selected: [],
      processMessage: i18n.t('app.delete_selected_confirmation', { entity: i18n.t('certificates.header').toLowerCase() }),
      isNotice: false,
      noticeType: ''
    }
  },
  computed: {
    hasModuleImportaciones () {
      return this.$store.getters['auth/hasImportacionesModule']
    },
    hasAnyImportaciones () {
      return this.$store.getters['auth/hasAnyImportaciones']
    },
    isClientFilterActive () {
      return this.$store.getters[this.vuexnamespace + '/isClientFilterActive']
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterNav']
    },
    accionesCertificados () {
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 1) {
        const acciones = this.accionesCertificadosBase.filter(x => x.id === 2)
        return acciones
      } else {
        return this.accionesCertificadosBase
      }
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return `${i18n.t('app.export_excel')} (${i18n.t('app.selected')})`
      return i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? i18n.t('app.only_selected') : i18n.t('app.see_all')
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    allCifs: function () {
      this.$store.getters['app/allCifs'].forEach(row => {
        this.links.push({ id: row.IdCIFEmpresa, value: row.CIF })
      })
      return this.$store.getters['app/allCifs']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    columns: function () {
      const empty = () => true
      return this.kendo.columns.filter(x => 
        !Object.keys(x.only || {}).length || 
        Object.keys(x.only).every(key => (this.tiposOnly[key] || empty)({ items: x.only[key], store: this.$store, route: this.$route }))
      )
    },
    tiposCert: function () {
      return this.$store.getters['config/TIPOS_CERT']
    },
  },
  watch: {
    $route (to, from) {
      this.checkIsNotice(to, from)
      this.updateOnRouteChange(to, from)
      // this.routerChangeHandler()
    },
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
  },
  created: function () {
    if (this.isRoleUserOrConsulta) {
      this.kendo.columns = this.kendo.columns.filter(x => x.field !== 'selected')
    } 
    // if (this.isRoleUserOrConsulta) this.kendo.columns.shift()
    if (this.$route.meta && this.$route.meta.notice !== undefined && this.$route.meta.notice !== null) {
      this.isNotice = true
      this.noticeType = this.$route.meta.notice
      if (this.noticeType === 'certificadoscaducar') {
        this.header.title = i18n.t('avisos.noticesCertsCaduc')
      } else if (this.noticeType === 'certificadoscaducados') {
        this.header.title = i18n.t('avisos.noticesCertsCaducados')
      } else {
        console.error(i18n.t('feedback.error.noticetype_not_found_error'))
      }
    } else {
      this.isNotice = false
      this.noticeType = ''
      this.header.title = i18n.t('certificates.header')
    }
    if (this.$route.params.data) {
      this.filterByParamsData()
    }
  },
  mounted: async function () {
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    if (this.actualFilterNav && this.isClientFilterActive && !this.hasClientFilterData) {
      const filter = this.masterFilters
      filter.empresa = { label: i18n.t('clients.entity_name'), value: this.actualFilterNav }
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
    }
    this.data = await this.applyFilters()
  },
  methods: {
    toggleImport () {
      this.showModalImport = !this.showModalImport
    },
    toggleImportCertsSerial () {
      this.showModalImportCertsSerial = !this.showModalImportCertsSerial
    }, 
    applyImport: async function (files, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const certificados = []
        const listPromises = []
        // Ejemplo promesas multiples asincronas con espera final de todas
        files.forEach((file) => {
          listPromises.push(this.getBase64(file.raw)
            .then(res => {
              const b64 = res.split(',')[1]
              certificados.push({
                Base64: b64,
                Nombre: file.name
              })
            }))
        })
        await Promise.all(listPromises)
        const payload = {
          idCliente: form.idCliente,
          Password: form.value,
          VincularEmpresas: form.switch,
          Certificados: certificados,
        }
        const response = await importCertificates(payload)
        if (response.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.toggleImport() 
          this.doFeedback(i18n.t('imports.processing'), 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyImportCertsSerial: async function (file, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importCertsSerial(file, { idCliente: form.idCliente })
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.toggleImportCertsSerial() 
          this.doFeedback(i18n.t('imports.processing'), 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateCertsSerial: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateCertsSerial()
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.downloadBlob(response, 'plantilla-importacion-certificados-serial.xlsx')
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    filterByParamsData: function () {
      const data = this.$route.params.data
      const filters = {}
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'cliente') {
            this.hasClientFilterData = true
            const cliente = { label: i18n.t('clients.entity_name'), value: { Nombre: filter.data.label, idCliente: filter.data.id } }
            filters.empresa = cliente
          } else {
            filters[filter.type] = filter.data
          }
        })
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filters)
      }
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.id === 2) { // Borrar
        this.deleteCertificate()
      } else { // Sustituir
        this.replaceCertificate()
      }
    },
    replaceCertificate () {
      this.$router.push({ 
        name: 'certificates/replace',
        params: { 
          idCliente: this.selected[0].idCliente, 
          serial: this.selected[0].SerialNumber, 
          tipoCertificado: this.selected[0].TipoCertificado, 
          name: this.selected[0].CommonName, 
          noticeType: this.noticeType 
        } 
      })
    },
    checkIsNotice: function (to, from) {
      if (to.meta && to.meta.notice !== undefined) {
        this.isNotice = true
        this.noticeType = to.meta.notice
        if (this.noticeType === 'certificadoscaducar') {
          this.header.title = i18n.t('avisos.noticesCertsCaduc')
        } else if (this.noticeType === 'certificadoscaducados') {
          this.header.title = i18n.t('avisos.noticesCertsCaducados')
        } else {
          console.error(i18n.t('feedback.error.noticetype_not_found_error'))
        }
      } else {
        this.isNotice = false
        this.noticeType = ''
        this.header.title = i18n.t('certificates.header')
      }
    },
    updateOnRouteChange: async function (to, from) {
      await this.applyFilters()
    },
    openPath: function (event) {
      this.$router.push({ 
        name: 'certificates/detail', 
        params: { 
          idCliente: event.dataItem.idCliente, 
          serial: event.dataItem.SerialNumber, 
          tipoCertificado: event.dataItem.TipoCertificado, 
          name: event.dataItem.CommonName, 
          noticeType: this.noticeType 
        } 
      })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        serial: data.serial ? data.serial.value : null,
        commonName: data.name ? data.name.value : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value?.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value?.idCliente : null,
        fechaCaducidadDesde: data.expires_from ? data.expires_from.value : null,
        fechaCaducidadHasta: data.expires_to ? data.expires_to.value : null,
        tipoCert: data.tipoCert ? data.tipoCert.value : null,
        enUso: data.enUso ? data.enUso.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: objOrder.order, grupos: objColumnas }
      if (this.hasSelected) {
        const selectedIDs = this.selected.map(({ TipoCertificado, idCliente, SerialNumber }) => 
          ({ TipoCertificado, idCliente, SerialNumber })
        )
        payload.listaIDs = selectedIDs
      }
      try {
        if (this.isNotice) {
          if (this.noticeType === 'certificadoscaducar') {
            params.porCaducar = true
          } else if (this.noticeType === 'certificadoscaducados') {
            params.caducados = true
          } else {
            console.error(i18n.t('feedback.error.noticetype_not_found_error'))
          }
        }
        const response = await downloadExcel(payload, params)

        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'certificados.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      this.$store.commit(this.vuexnamespace + '/setClientFilterActive', !!((data.empresa && data.empresa.value.idCliente === this.actualFilterNav?.idCliente) || (this.hasClientFilterData)))
      const params = {
        serial: data.serial ? data.serial.value : null,
        commonName: data.name ? data.name.value : null,
        idDistribuidor: data.distribuidor ? data.distribuidor.value?.idDistribuidor : null,
        idCliente: data.empresa ? data.empresa.value?.idCliente : null,
        fechaCaducidadDesde: data.expires_from ? data.expires_from.value : null,
        fechaCaducidadHasta: data.expires_to ? data.expires_to.value : null,
        tipoCert: data.tipoCert ? data.tipoCert.value : null,
        enUso: data.enUso ? data.enUso.value : null,
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const data = await this.getItemsData(objOrder, params)
        return data.map(item => {
          item.TipoCertificadoNombre = this.tiposCert.find(x => x.id === item.TipoCertificado)?.name ?? item.TipoCertificadoNombre
          return item
        })
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }

      // if (this.data !== null) {
      //   this.data.forEach(o => {
      //     o.FechaCaducidad = moment(o.FechaCaducidad).format('DD-MM-yyyy HH:mm')
      //   })
      // }
      return this.data
    },
    getItemsData: async function (orders, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(orders, params)
      if (res.blnError === false) {
        this.data = res.respuesta
        const pagination = {
          total: res.meta?.total,
          currentPage: res.meta?.currentPage,
          totalPages: res.meta?.lastPage,
          pageSize: res.meta?.perPage
        }
        this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
        this.$store.commit('setIsLoading', false)
      } else {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', res))
      }
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (orders, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      if (this.isNotice) {
        if (this.noticeType === 'certificadoscaducar') {
          params.porCaducar = true
        } else if (this.noticeType === 'certificadoscaducados') {
          params.caducados = true
        } else {
          console.error(i18n.t('feedback.error.noticetype_not_found_error'))
        }
      }
      const data = await getCertificatesPag(orders, params)

      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      this.unselect()
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    unselect: function () {
      this.selected = []
    },
    deleteCertificate: async function () {
      this.showModal = !this.showModal
    },
    deleteHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = []
        for (const element of this.selected) {
          payload.push({
            Serialnumber: element.SerialNumber,
            idCliente: element.idCliente,
            tipoCertificado: element.TipoCertificado
          })
        }
        const response = await deleteCertificate(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.unselect()
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    goToNewCertificate: function () {
      this.$router.push({ name: 'certificates/detail', params: { idCliente: -1, serial: -1, tipoCertificado: -1 } })
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped></style>
